export enum ProfileAdditionalRole {
  Dev = 'dev',
}

export type ProfileRoleList = ProfileAdditionalRole[];
